// Ad-conversion types a custom event can be mapped to (domain
// customEventConversions). Canonical names = Meta standard events; the backend
// translates them per ad platform. Descriptions are shown under each option to
// help operators pick the right one.
export const CONVERSION_EVENTS = [
  { value: 'Schedule', label: 'Schedule', description: 'Books an appointment to visit a location — a reservation, booking, or test ride.' },
  { value: 'Lead', label: 'Lead', description: 'A sign-up or interest submission — a form, quote request, or "contact me".' },
  {
    value: 'CompleteRegistration',
    label: 'Complete registration',
    description: 'A registration form is completed — account, membership, or newsletter sign-up.',
  },
  { value: 'Contact', label: 'Contact', description: 'A person initiates contact via phone, SMS, email, or chat.' },
  {
    value: 'SubmitApplication',
    label: 'Submit application',
    description: 'A person applies for a product, service, or program — loan, job, or course.',
  },
  { value: 'StartTrial', label: 'Start trial', description: 'A person starts a free trial.' },
  { value: 'Subscribe', label: 'Subscribe', description: 'A person starts a paid subscription or membership.' },
  {
    value: 'FindLocation',
    label: 'Find location',
    description: 'A person searches for a store location, intending to visit.',
  },
  { value: 'Donate', label: 'Donate', description: 'A donation is made.' },
];

// Releva analytics conversion types. These drive Releva's own classification —
// how an event is counted in Reports & Analytics — and are NOT forwarded
// through the ad-conversion table (the classification itself already drives
// their ad-platform forwarding). They live here so the unified conversions
// table can offer them as row types and attach a fixed fallback value (used
// when an event carries no products/value of its own).
export const ANALYTICS_CONVERSION_EVENTS = [
  { value: 'Purchase', label: 'Purchase', description: 'A completed order — counted as a conversion in Reports & Analytics.' },
  { value: 'AddToCart', label: 'Engagement', description: 'An add-to-cart / engagement — counted as an engagement in Reports & Analytics.' },
  { value: 'CartCreate', label: 'Cart create', description: 'A cart is created — counted as a cart creation in Reports & Analytics.' },
];

// Every conversion type, for label/description lookup across both groups.
export const ALL_CONVERSION_EVENTS = [...ANALYTICS_CONVERSION_EVENTS, ...CONVERSION_EVENTS];

export default CONVERSION_EVENTS;
